<template>

    <form class="">

        <div class="row row-cols-2 row-cols-md-2 row-cols-lg-5 g-3">
            <!--            <div class="col" v-if="categories">
                            <multi-filter label="categories" :options="categories" v-model="form.categories" />
                        </div>-->
            <div class="col" v-if="supplierOptions.length">
                <multi-filter label="suppliers" :options="supplierOptions" v-model="form.suppliers" />
            </div>
            <div class="col" v-if="manufacturerOptions.length">
                <multi-filter label="manufacturers" :options="manufacturerOptions" v-model="form.manufacturers" />
            </div>
            <!--        @todo    <div class="col" v-if="brandOptions.length">
                            <multi-filter label="brands" :options="brandOptions" v-model="form.brands" />
                        </div>-->
            <div class="col" v-if="minPrice || maxPrice">
                <range-filter label="price" :min="minPrice" :max="maxPrice" v-model="form.price_range" />
            </div>
            <div class="col" v-if="paymentMethodOptions.length">
                <multi-filter label="payment_methods" :options="paymentMethodOptions" v-model="form.payment_methods" />
            </div>
            <div class="col">
                <single-filter label="in_stock" v-model="form.in_stock" />
            </div>
            <div class="col">
                <single-filter label="free_delivery" v-model="form.free_delivery" />
            </div>
        </div>

        <!--   @todo     <div v-if="filterProperties.length">
        
                    <div class="my-3">
                        {{ __('Weitere Filter') }}
                    </div>
        
                    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4">
                        <div class="col" v-for="property in filterProperties">
                            <multi-filter :label="property.name" :options="property.values" />
                        </div>
                    </div>
        
                </div>-->

        <div class="mt-3 d-flex gap-3" v-if="activeFilters">
            <div class="d-flex gap-3" v-for="(filterName, filterKey) in activeFilters" v-if="activeFilters[filterKey].length">
                <!--                <div>
                                    {{ __(filterKey) }}
                                </div>-->
                <div class="d-flex gap-1">
                    <span class="badge rounded-pill bg-light text-dark border border-secondary d-flex align-items-center" v-for="filterItem in activeFilters[filterKey]">
                        {{ filterItem.label }}
                        <button type="button" class="btn p-0 ms-1" @click="removeFilter(filterKey, filterItem.id)">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="d-flex gap-3">
                <!--                <button type="button" class="btn btn-lg btn-primary" @click="applyFilters">
                                    <i class="bi bi-check-lg"></i>
                                    {{ __('Filter anwenden') }}
                                </button>-->
                <button type="button" class="btn btn-outline-danger" @click="reset">
                    <i class="bi bi-x-lg"></i>
                    {{ __('Filter zurücksetzen') }}
                </button>
            </div>
        </div>

    </form>

</template>


<script>
    import MultiFilter from '@/shared/Filters/MultiFilter';
    import RangeFilter from '@/shared/Filters/RangeFilter';
    import SingleFilter from '@/shared/Filters/SingleFilter';

    export default {
        props: [
            'filters',
            'filterProperties',
            'supplierOptions',
            'manufacturerOptions',
            'brandOptions',
            'paymentMethodOptions',
            'minPrice',
            'maxPrice',
        ],
        components: {
            MultiFilter,
            RangeFilter,
            SingleFilter,
        },
        data() {
            return {
                form: {
//                    categories: this.filters.categories || [],
                    suppliers: this.filters.suppliers || [],
                    brands: this.filters.brands || [],
                    manufacturers: this.filters.manufacturers || [],
                    payment_methods: this.filters.payment_methods || [],
                    in_stock: this.filters.in_stock || false,
                    free_delivery: this.filters.free_delivery || false,
                    price_range: {
                        min: this.filters.price_range ? this.filters.price_range.min : this.minPrice,
                        max: this.filters.price_range ? this.filters.price_range.max : this.maxPrice,
                    }
                },
            }
        },
        mounted() {
            // @todo
//            axios.get(route('suppliers.index')).then((response) => {
//                _.each(response.data, (o) => {
//                    this.suppliers[o.id] = o.name;
//                });
//            });
//            axios.get(route('categories.index')).then((response) => {
//                _.each(response.data, (o) => {
//                    this.categories[o.id] = o.name;
//                });
//            });
//            axios.get(route('brands.index')).then((response) => {
//                _.each(response.data, (o) => {
//                    this.brands[o.id] = o.name;
//                });
//            });
//            axios.get(route('manufacturers.index')).then((response) => {
//                _.each(response.data, (o) => {
//                    this.manufacturers[o.id] = o.name;
//                });
//            });
        },
        watch: {
            form: {
                deep: true,
                handler: function () {
                    let url = window.location.href.split('?')[0];
                    this.form.search = this.$page.props.searchQuery;
                    this.$inertia.get(url, this.form, {preserveState: true, preserveScroll: true})
                },
            },
        },
        computed: {
            activeFilters() {
                var filters = {};
                filters.suppliers = this.supplierOptions.filter(option => this.form.suppliers.includes(option.id));
                filters.manufacturers = this.manufacturerOptions.filter(option => this.form.manufacturers.includes(option.id));
                filters.brands = this.brandOptions.filter(option => this.form.brands.includes(option.id));
                filters.payment_methods = this.paymentMethodOptions.filter(option => this.form.payment_methods.includes(option.id));

                console.log(filters);

                return filters;
            }
        },
        methods: {
//            applyFilters() {
//                console.log(this.filters);
//                let url = window.location.href.split('?')[0];
//                this.$inertia.get(url, this.filters, {
//                    preserveState: true,
//                    preserveScroll: true,
//                    only: ['products']
//                })
//            },
            removeFilter(name, id) {
                this.form[name] = _.without(this.form[name], id);
            },
            reset() {
//                this.form = _.mapValues(this.form, () => null);

                var searchParams = new URLSearchParams();

                searchParams.set('search', this.$page.props.searchQuery);

                let url = window.location.href.split('?')[0] + '?' + searchParams.toString();
                this.$inertia.get(url, {}, {preserveState: false, preserveScroll: true});
            },
        }
    }
</script>

<style scoped>

</style>